"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMessageBarContextValue_unstable", {
    enumerable: true,
    get: function() {
        return useMessageBarContextValue_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useMessageBarContextValue_unstable(state) {
    const { layout, actionsRef, bodyRef, titleId } = state;
    const messageBarContext = _react.useMemo(()=>({
            layout,
            actionsRef,
            bodyRef,
            titleId
        }), [
        layout,
        actionsRef,
        bodyRef,
        titleId
    ]);
    return {
        messageBar: messageBarContext
    };
}
